module.exports = __webpack_public_path__ + "static/media/privacy.1c69350f.txt";